import { ModuleLink } from "components/common/moduleNavigation/moduleTypes/moduleTypes";
import chairIcon from "assets/images/chairAlt.svg";
import { Dashboard } from "routes/manufacturingNew/Dashboard";

export const indexes: ModuleLink = {
  url: "indexes",
  label: "Indeksy",
  icon: chairIcon,
  subSection: <></>,
  routing: Dashboard,
  isAccessible: false,
};
